import { Component, Input, OnInit } from "@angular/core";
import { AuthService } from "src/app/auth.service";
import { DataServiceService } from "src/app/data-service.service";
import { User } from "../../model/login";

@Component({
  selector: "app-new-print-header",
  templateUrl: "./new-print-header.component.html",
  styleUrls: ["./new-print-header.component.scss"],
})
export class NewPrintHeaderComponent implements OnInit {
  @Input() reportTitle = "iKYC Search Results Report";

  public hongKongDT;
  public companyName;
  userDetails: User;
  isLoading: boolean = true;
  constructor(
    private dataService: DataServiceService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.hongKongDT = localStorage.getItem("searchDateAndTime");

    this.getUserDetails().then((data) => {
      this.isLoading = false;
    });
  }

  async getUserDetails() {
    this.userDetails = await this.dataService.getUserDetailsById(
      this.authService.getCurrentUser().userId
    );
    this.userDetails = this.userDetails[0];
  }
} 